import { DebounceInput } from 'react-debounce-input';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import media from 'styled-media-query';

export const MainSearchWrapper = styled.div`
	background-color: var(--main-color);
    display: ${({display}) => display ? 'block' : 'none'};
`;

export const MainSearchContent = styled.div`
    align-items: center;
    display: flex;
    height: var(--main-search-height);

    ${media.lessThan('medium')`
        flex-direction: column;
        justify-content: center;
	`}

    ${media.greaterThan('medium')`
        justify-content: space-between;
	`}
`;

export const MainSearchText = styled.p`
    color: #ffffff;
    font-size: ${({isHome}) => isHome ? '2rem' : '1.5rem'};

    ${media.lessThan('medium')`
        font-size: 1.5rem;
        margin-bottom: 1rem;
        text-align: center;
	`}
`;

export const MainSearch = styled.div`
    align-items: center;
    background-color: #fff;
    border-radius: 0.5rem;
    display: flex;
    position: relative;

    &::after,
    &:before {
        content: '';
        position: absolute;
    }

    ${media.lessThan('medium')`
        width: 100%;
	`}

    ${media.greaterThan('medium')`
        width: 20rem;
	`}
`

export const MainSearchIcon = styled.div`
    padding-right: 1rem;
    height: 1rem;
`;

export const MainSearchInput = styled(DebounceInput)`
    border: none;
    border-radius: 0.5rem;
    font-size: 1rem;
    height: 50px;
    padding: 1rem;
    width: 100%;

    &::placeholder {
		color: #BDBDBD;
	}
`;

export const MainSearchResults = styled.div`
    background-color: #fff;
    border-radius: 0.5rem;
    box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.1);
    display: none;
    padding: 0.25rem 1rem;
    position: absolute;
    top: calc(100% + 0.5rem);
    width: 100%;
    z-index: 4000;
`;

export const ResultLink = styled(Link)`
    display: block;
    padding: 1rem 0;
`;

export const ResultEmpty = styled.div`
    padding: 1rem 0;
    text-align: center;
`;
